import i18nFactory from '@yandex-int/i18n';
import { get } from 'lodash';

import { createErrorsMapper } from '../ErrorsMapper/ErrorsMapper';

import * as keyset from './InternalToolsErrorsMappers.i18n';

const i18n = i18nFactory(keyset);

export const internalProductsErrorsMapper = createErrorsMapper<{}>(
    ({ idx }) => [
        {
            path: ['productDescription'],
            codes: [
                {
                    code: 'StringDefectIds.LENGTH_CANNOT_BE_MORE_THAN_MAX',
                    message: (err): string =>
                        i18n('product-description-cannot-be-more-than-max', {
                            maxLength: get(err, 'params.maxLength', '')
                        })
                }
            ]
        },
        {
            path: ['productName'],
            codes: [
                {
                    code: 'StringDefectIds.LENGTH_CANNOT_BE_MORE_THAN_MAX',
                    message: (err): string =>
                        i18n('product-name-cannot-be-more-than-max', {
                            maxLength: get(err, 'params.maxLength', '')
                        })
                }
            ]
        },
        {
            path: ['productName'],
            codes: [
                {
                    code: 'InternalAdDefectIds.PRODUCT_WITH_THIS_NAME_ALREADY_EXISTS',
                    message: (err): string => i18n('product-with-this-name-already-exists')
                }
            ]
        }
    ],
    error => i18n('unknown-error-text')
);
